module.exports = __webpack_public_path__ + "img/balanca.8308455b.svg";